'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./select.scss');

var _chip = require('../chip');

var _chip2 = _interopRequireDefault(_chip);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _validation = require('../with-form-field/validation');

var _validation2 = _interopRequireDefault(_validation);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  /* Lifecycle */
  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    var searchValueIndex = -1;

    if (props) {
      var _ref = props || _this.props,
          options = _ref.options,
          searchByKey = _ref.searchByKey,
          searchValue = _ref.searchValue;

      searchValueIndex = options.findIndex(function (option) {
        if (searchByKey && searchValue) {
          return option[searchByKey] === searchValue;
        }

        return false;
      });
    }

    _this.state = {
      activeValue: searchValueIndex,
      isOpen: false,
      multipleOptions: [],
      searchValue: '',
      selectedOption: null,
      activeMultipleOption: [],
      editableMultipleOption: '',
      editableMultipleOptionValue: '',
      shouldFilter: false,
      totalOptionsAvailable: 0
    };

    _this.validationHeight = 30;
    _this.offsetMargin = 40;

    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleCtrlAKey = _this.handleCtrlAKey.bind(_this);
    _this.openMenu = _this.openMenu.bind(_this);
    _this.resetState = _this.resetState.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.selectFromOptionsList = _this.selectFromOptionsList.bind(_this);
    _this.saveEditableChipValue = _this.saveEditableChipValue.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  _createClass(Select, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var multipleOptions = this.state.multipleOptions;
      var _props = this.props,
          selected = _props.selected,
          searchValue = _props.searchValue;


      if (selected) {
        this.setState({
          multipleOptions: [].concat(_toConsumableArray(new Set(multipleOptions.concat(this.props.selected))))
        });
      }

      if (searchValue) {
        this.setState({ searchValue: searchValue });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var searchValue = this.props.searchValue;


      if (nextProps.searchValue !== undefined && searchValue !== nextProps.searchValue) {
        this.setState({ searchValue: nextProps.searchValue });
      }

      if (nextProps.selected) {
        this.setState({
          multipleOptions: [].concat(_toConsumableArray(new Set(this.state.multipleOptions.concat(nextProps.selected)))),
          searchValue: nextProps.searchValue || ''
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (!this.state.isOpen && nextState.isOpen) {
        document.addEventListener('click', this.closeMenu, false);
        document.addEventListener('touchstart', this.closeMenu, false);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.multipleEditableChipInput) {
        this.multipleEditableChipInput.focus();
        this.multipleEditableChipInput.select();
      }
      if (prevState.isOpen && !this.state.isOpen) {
        document.removeEventListener('click', this.closeMenu, false);
        document.removeEventListener('touchstart', this.closeMenu, false);
      }

      if (this.activeOptionElement) {
        (0, _utils.scrollToElement)(this.activeOptionElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeMenu, false);
      document.removeEventListener('touchstart', this.closeMenu, false);
    }

    /* Getters / Setters */

  }, {
    key: 'getMaxHeight',
    value: function getMaxHeight() {
      var selectClientRect = this.select.getBoundingClientRect();
      var maxOptionsHeight = selectClientRect.top;
      var searchableAreaHeight = this.select.querySelector('.field-wrapper').clientHeight;

      return 'calc(100vh - ' + (maxOptionsHeight + searchableAreaHeight + this.offsetMargin) + 'px)';
    }
  }, {
    key: 'getSelectDimensions',
    value: function getSelectDimensions() {
      var state = this.props.state;


      var maxHeight = this.getMaxHeight();
      var paddingBottom = state ? this.validationHeight + 'px' : 0;

      return {
        maxHeight: maxHeight,
        paddingBottom: paddingBottom
      };
    }
  }, {
    key: 'getOptionsLength',
    value: function getOptionsLength() {
      var filteredOptions = this.filterOptionsData();

      return filteredOptions.length;
    }

    /* Options filters */

  }, {
    key: 'filterInOptionsBySearchValue',
    value: function filterInOptionsBySearchValue(options) {
      var _this2 = this;

      var searchByKey = this.props.searchByKey;
      var searchValue = this.state.searchValue;


      if (!searchValue) return options;

      return options.filter(function (row) {
        if (row[searchByKey] === undefined) {
          console.warn('A value does not exist, check data!');
          return false;
        }

        return _this2.isSearchedFoundInOptions(row);
      });
    }
  }, {
    key: 'filterInOptionsByMultipleOptions',
    value: function filterInOptionsByMultipleOptions(options) {
      var _this3 = this;

      var searchByKey = this.props.searchByKey;


      return options.filter(function (row) {
        return !_this3.state.multipleOptions.includes(row[searchByKey]);
      });
    }
  }, {
    key: 'filterOptionsData',
    value: function filterOptionsData() {
      var _props2 = this.props,
          multiple = _props2.multiple,
          options = _props2.options,
          searchable = _props2.searchable;
      var shouldFilter = this.state.shouldFilter;


      var optionsClone = [].concat(options);

      if (searchable && shouldFilter) {
        optionsClone = this.filterInOptionsBySearchValue(optionsClone);
      }

      if (multiple && this.state.multipleOptions.length > 0) {
        optionsClone = this.filterInOptionsByMultipleOptions(optionsClone);
      }

      return optionsClone;
    }

    /* Event listener methods */

  }, {
    key: 'openMenu',
    value: function openMenu(event) {
      event.stopPropagation();
      var _state = this.state,
          activeMultipleOption = _state.activeMultipleOption,
          editableMultipleOption = _state.editableMultipleOption;


      if (activeMultipleOption.length === 0 && !editableMultipleOption) {
        this.setState({ isOpen: true });
      }
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu(event) {
      event.stopPropagation();
      // eslint-disable-next-line
      if (this && _reactDom2.default.findDOMNode(this)) {
        // eslint-disable-next-line
        if (_reactDom2.default.findDOMNode(this).contains(event.target)) {
          return;
        }
      }

      this.resetState();
    }
  }, {
    key: 'toggle',
    value: function toggle(event) {
      event.stopPropagation();
      event.preventDefault();
      this.setState({ isOpen: !this.state.isOpen, activeValue: -1 });
    }
  }, {
    key: 'search',
    value: function search(event) {
      var _this4 = this;

      var value = event.target.value;

      this.setState({ searchValue: value, shouldFilter: true }, function () {
        if (_this4.props.onChange) {
          _this4.props.onChange(value);
        }
      });
    }
  }, {
    key: 'selectFromOptionsList',
    value: function selectFromOptionsList(option) {
      var _props3 = this.props,
          multiple = _props3.multiple,
          optionLabel = _props3.optionLabel,
          optionValue = _props3.optionValue;
      var multipleOptions = this.state.multipleOptions;


      if (multiple) {
        var multipleOptionsClone = multipleOptions.slice();
        multipleOptionsClone.push(option[optionLabel]);

        this.setState({ multipleOptions: multipleOptionsClone, searchValue: '' });
      } else {
        this.setState({ selectedOption: option, searchValue: option[optionLabel] });
      }

      this.setState({
        isOpen: false
      });

      if (this.props && this.props.onSelection) {
        this.props.onSelection(option[optionValue]);
      }

      /* Because of redux-forms!! This might break stuff :D */
      if (!multiple && this.props && this.props.onChange) {
        this.props.onChange(option[optionValue]);
      }
    }
  }, {
    key: 'handleMultipleOptionRemove',
    value: function handleMultipleOptionRemove(optionToRemove) {
      var _this5 = this;

      var multipleOptions = this.state.multipleOptions;


      this.setState({ multipleOptions: multipleOptions.filter(function (option) {
          return option !== optionToRemove;
        }) }, function () {
        if (_this5.props && _this5.props.onSelection) {
          _this5.props.onSelection(_this5.state.multipleOptions);
        }
      });
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      var options = this.props.options;

      switch (event.key) {
        case _utils.KEYS.UP:
          if (options) {
            this.handleUpKey();
          }
          break;
        case _utils.KEYS.DOWN:
          if (options) {
            this.handleDownKey();
          }
          break;
        case _utils.KEYS.ENTER:
          this.handleEnterKey(event);
          break;
        case _utils.KEYS.ESCAPE:
          this.resetState();
          this.handleEnterKey();
          break;
        default:
          this.setState({ isOpen: true });
          break;
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      switch (event.key) {
        case _utils.KEYS.BACKSPACE:
          this.handleBackspaceKey();
          break;
        case _utils.KEYS.A:
          if (event.metaKey || event.ctrlKey) {
            this.handleCtrlAKey();
          }
          break;
        case _utils.KEYS.C:
          if (event.metaKey || event.ctrlKey) {
            this.handleCtrlCKey();
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: 'handleUpKey',
    value: function handleUpKey() {
      var activeValue = this.state.activeValue;

      var dataLength = this.getOptionsLength();

      this.setState({
        activeValue: activeValue - 1 < 0 ? dataLength - 1 : activeValue - 1
      });
    }
  }, {
    key: 'handleDownKey',
    value: function handleDownKey() {
      var activeValue = this.state.activeValue;

      var dataLength = this.getOptionsLength();

      this.setState({
        activeValue: activeValue + 1 >= dataLength ? 0 : activeValue + 1,
        isOpen: true
      });
    }
  }, {
    key: 'handleEnterKey',
    value: function handleEnterKey(event) {
      var _this6 = this;

      event.preventDefault();
      var _props4 = this.props,
          multiple = _props4.multiple,
          searchable = _props4.searchable,
          options = _props4.options;
      var _state2 = this.state,
          multipleOptions = _state2.multipleOptions,
          searchValue = _state2.searchValue;

      var trimmedSearchValue = searchValue.trim();

      if (multiple && searchable && trimmedSearchValue) {
        var uniqueMultipleOptions = new Set(multipleOptions);
        uniqueMultipleOptions.add(trimmedSearchValue);

        this.setState({ multipleOptions: [].concat(_toConsumableArray(uniqueMultipleOptions)), searchValue: '' }, function () {
          if (_this6.props && _this6.props.onSelection) {
            _this6.props.onSelection(_this6.state.multipleOptions);
          }
        });
      } else if (options.lenght > 0) {
        var filteredOptions = this.filterOptionsData();
        var selected = filteredOptions[this.state.activeValue];
        this.selectFromOptionsList(selected);
      }

      this.setState({ isOpen: false, activeValue: -1 });
    }
  }, {
    key: 'handleBackspaceKey',
    value: function handleBackspaceKey() {
      var _this7 = this;

      var _props5 = this.props,
          multiple = _props5.multiple,
          searchable = _props5.searchable;
      var _state3 = this.state,
          multipleOptions = _state3.multipleOptions,
          activeMultipleOption = _state3.activeMultipleOption,
          searchValue = _state3.searchValue;


      if (multiple && searchable && !searchValue) {
        var deleteOption = multipleOptions[multipleOptions.length - 1];

        this.setState({
          multipleOptions: multipleOptions.slice(0, -1),
          activeMultipleOption: [].concat(_toConsumableArray(activeMultipleOption.filter(function (el) {
            return el !== deleteOption;
          })))
        }, function () {
          if (_this7.props && _this7.props.onSelection) {
            _this7.props.onSelection(_this7.state.multipleOptions);
          }
        });
      }
    }
  }, {
    key: 'handleCtrlAKey',
    value: function handleCtrlAKey() {
      var multiple = this.props.multiple;
      var _state4 = this.state,
          multipleOptions = _state4.multipleOptions,
          searchValue = _state4.searchValue;

      if (multiple && multipleOptions && !searchValue) {
        this.setState({
          activeMultipleOption: [].concat(multipleOptions)
        });
      }
    }
  }, {
    key: 'handleCtrlCKey',
    value: function handleCtrlCKey() {
      var multiple = this.props.multiple;
      var activeMultipleOption = this.state.activeMultipleOption;

      if (multiple && activeMultipleOption) {
        this.copyToClipboard(activeMultipleOption.join(','));
        this.setState({
          isOpen: false,
          activeMultipleOption: []
        });
      }
    }
  }, {
    key: 'handleEditableChipOnKeyDown',
    value: function handleEditableChipOnKeyDown(event, option) {
      if (event.key === _utils.KEYS.ENTER || event.key === _utils.KEYS.TAB) {
        this.saveEditableChipValue(event, option);
      }
    }
  }, {
    key: 'handleEditableChipOnChange',
    value: function handleEditableChipOnChange(event) {
      var value = event.target.value;
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: 'saveEditableChipValue',
    value: function saveEditableChipValue(event, option) {
      var _this8 = this;

      var multipleOptions = this.state.multipleOptions;

      var editedMultipleOptionsList = [].concat(multipleOptions);
      editedMultipleOptionsList[editedMultipleOptionsList.findIndex(function (el) {
        return el === option;
      })] = event.target.value;

      this.setState({
        activeMultipleOption: [],
        editableMultipleOption: '',
        multipleOptions: editedMultipleOptionsList
      }, function () {
        if (_this8.props.onSelection) {
          _this8.props.onSelection(_this8.state.multipleOptions);
        }
      });

      this.multipleEditableChipInput = null;
    }

    /* Utils */

  }, {
    key: 'isSearchedFoundInOptions',
    value: function isSearchedFoundInOptions(dataObject) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fullMatch: false },
          fullMatch = _ref2.fullMatch;

      var searchByKey = this.props.searchByKey;
      var searchValue = this.state.searchValue;


      var searchableTextStripped = dataObject[searchByKey].toString().toLocaleLowerCase();
      var searchValueStripped = searchValue.toString().toLocaleLowerCase();

      return fullMatch ? searchableTextStripped === searchValueStripped : searchableTextStripped.includes(searchValueStripped);
    }
  }, {
    key: 'copyToClipboard',
    value: function copyToClipboard(value) {
      var tempInput = document.createElement('input');
      tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
      tempInput.value = value;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    }
  }, {
    key: 'resetState',
    value: function resetState() {
      var optionLabel = this.props.optionLabel;
      var _state5 = this.state,
          selectedOption = _state5.selectedOption,
          searchValue = _state5.searchValue;


      this.setState({
        isOpen: false,
        activeValue: -1,
        activeMultipleOption: [],
        editableMultipleOption: '',
        selectedOption: null,
        shouldFilter: false,
        searchValue: selectedOption ? selectedOption[optionLabel] : searchValue
      });
    }

    /* Render methods */

  }, {
    key: 'renderOptionsList',
    value: function renderOptionsList(options) {
      var _this9 = this;

      var _props6 = this.props,
          groupByKey = _props6.groupByKey,
          template = _props6.template,
          optionValue = _props6.optionValue,
          _props6$optionLabel = _props6.optionLabel,
          optionLabel = _props6$optionLabel === undefined ? optionValue : _props6$optionLabel;

      var dataGroup = '';

      return options.map(function (dataItem, index) {
        var isDataGroupDiff = groupByKey && dataGroup !== dataItem[groupByKey];
        if (isDataGroupDiff) {
          dataGroup = dataItem[groupByKey];
        }

        return _react2.default.createElement(
          'div',
          {
            key: index,
            'data-group': isDataGroupDiff ? dataGroup : null,
            className: (0, _utils.cn)('select__option', groupByKey && isDataGroupDiff && 'select__option--group-header', _this9.state.activeValue === index && 'select__option--active'),
            ref: function ref(el) {
              if (_this9.state.activeValue === index) {
                _this9.activeOptionElement = el;
              }
            },
            onMouseDown: function onMouseDown() {
              return _this9.selectFromOptionsList(dataItem);
            }
          },
          template && template(dataItem) || _react2.default.createElement(
            'div',
            { className: 'select__option--wrapper' },
            dataItem[optionLabel]
          )
        );
      });
    }
  }, {
    key: 'renderData',
    value: function renderData() {
      var _props7 = this.props,
          state = _props7.state,
          validationMessage = _props7.validationMessage;


      var filteredOptions = this.filterOptionsData();
      var optionsList = this.renderOptionsList(filteredOptions);
      var maxHeight = this.getSelectDimensions().maxHeight;
      var paddingBottom = this.getSelectDimensions().paddingBottom;

      var selectOptionsClasses = (0, _utils.cn)('select__options', state && 'select__options--' + state, optionsList.length === 0 && 'select__options--empty');

      return _react2.default.createElement(
        'div',
        { className: selectOptionsClasses, style: { maxHeight: maxHeight } },
        _react2.default.createElement(
          'div',
          { className: 'select__options-wrapper', style: { maxHeight: maxHeight, paddingBottom: paddingBottom } },
          optionsList
        ),
        state && _react2.default.createElement(_validation2.default, {
          className: 'select__validation',
          validationMessage: validationMessage,
          state: state
        })
      );
    }
  }, {
    key: 'renderSelectedMultipleOptions',
    value: function renderSelectedMultipleOptions() {
      var _this10 = this;

      var multiple = this.props.multiple;
      var _state6 = this.state,
          multipleOptions = _state6.multipleOptions,
          editableMultipleOption = _state6.editableMultipleOption;


      if (!multiple || multipleOptions.length === 0) {
        return null;
      }

      return multipleOptions.map(function (option, index) {
        if (option === editableMultipleOption) {
          return _this10.renderMultipleOptionsEditableChip(option, index);
        }
        return _this10.renderMultipleOptionsChip(option, index);
      });
    }
  }, {
    key: 'renderMultipleOptionsChip',
    value: function renderMultipleOptionsChip(option, index) {
      var _this11 = this;

      var searchable = this.props.searchable;
      var activeMultipleOption = this.state.activeMultipleOption;

      return _react2.default.createElement(
        _chip2.default,
        {
          key: index,
          selected: activeMultipleOption.includes(option),
          onClose: this.handleMultipleOptionRemove.bind(this, option),
          onClick: function onClick(e) {
            if (!searchable) {
              e.preventDefault();
              return;
            }
            if (e.shiftKey || e.ctrlKey || e.metaKey) {
              // if exists in list disselect
              if (activeMultipleOption.includes(option)) {
                _this11.setState({
                  activeMultipleOption: [].concat(_toConsumableArray(activeMultipleOption.filter(function (el) {
                    return el !== option;
                  })))
                });
              } else {
                _this11.setState({
                  activeMultipleOption: [].concat(_toConsumableArray(new Set(activeMultipleOption.concat(option))))
                });
              }
            } else {
              _this11.setState({
                activeMultipleOption: [].concat(option)
              });
            }
          },
          onDoubleClick: function onDoubleClick(e) {
            if (!searchable) {
              e.preventDefault();
              return;
            }

            _this11.setState({
              editableMultipleOption: option
            });
          }
        },
        option
      );
    }
  }, {
    key: 'renderMultipleOptionsEditableChip',
    value: function renderMultipleOptionsEditableChip(option, index) {
      var _this12 = this;

      return _react2.default.createElement('input', {
        key: index,
        ref: function ref(input) {
          _this12.multipleEditableChipInput = input;
        },
        style: {
          width: option.length * 8
        },
        className: 'select--multiple-edit',
        defaultValue: option,
        onChange: function onChange(value) {
          return _this12.handleEditableChipOnChange(value, option);
        },
        onKeyDown: function onKeyDown(event) {
          return _this12.handleEditableChipOnKeyDown(event, option);
        },
        onBlur: function onBlur(event) {
          return _this12.saveEditableChipValue(event, option);
        }
      });
    }
  }, {
    key: 'renderSuffixIcon',
    value: function renderSuffixIcon() {
      var isOpen = this.state.isOpen;
      var options = this.props.options;


      if (options.length === 0) {
        return null;
      }

      var icon = isOpen && options.length ? 'arrow-up' : 'arrow-down';

      return _react2.default.createElement(_icon2.default, { name: icon, size: '16', onClick: this.toggle });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var _props8 = this.props,
          className = _props8.className,
          multiple = _props8.multiple,
          options = _props8.options,
          size = _props8.size,
          shadow = _props8.shadow,
          searchable = _props8.searchable,
          props = _objectWithoutProperties(_props8, ['className', 'multiple', 'options', 'size', 'shadow', 'searchable']);

      var groupByKey = props.groupByKey,
          onSelection = props.onSelection,
          optionValue = props.optionValue,
          optionLabel = props.optionLabel,
          searchByKey = props.searchByKey,
          searchValue = props.searchValue,
          template = props.template,
          validationMessage = props.validationMessage,
          propsToPropagate = _objectWithoutProperties(props, ['groupByKey', 'onSelection', 'optionValue', 'optionLabel', 'searchByKey', 'searchValue', 'template', 'validationMessage']);

      var isOpen = this.state.isOpen;

      // redux form..

      if (!multiple) {
        delete propsToPropagate.onBlur;
        delete propsToPropagate.onFocus;
      }

      var classes = (0, _utils.cn)('select', size && 'select--' + size, isOpen && options && 'select--open', multiple && 'select--multiple', shadow && 'select--box-shadow', className);

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          onFocus: this.openMenu,
          onClick: this.openMenu,
          ref: function ref(select) {
            _this13.select = select;
          }
        },
        _react2.default.createElement(_input2.default, _extends({
          className: 'select__input',
          size: size,
          onChange: this.search,
          prefix: multiple && this.renderSelectedMultipleOptions(),
          onKeyUp: this.handleKeyUp,
          onKeyDown: this.handleKeyDown,
          readOnly: !searchable,
          padding: ['none', 'x-large', 'none', 'small']
        }, propsToPropagate, {
          value: this.state.searchValue
        })),
        options && _react2.default.createElement(
          'div',
          { className: 'select__dropdown-arrow' },
          this.renderSuffixIcon()
        ),
        isOpen && this.renderData()
      );
    }
  }]);

  return Select;
}(_react2.default.Component);

Select.propTypes = {
  className: _propTypes2.default.string,
  groupByKey: _propTypes2.default.string,
  multiple: _propTypes2.default.bool,
  options: _propTypes2.default.array,
  optionValue: _propTypes2.default.string,
  optionLabel: _propTypes2.default.string,
  onSelection: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  searchable: _propTypes2.default.bool,
  // TODO drop searchByKey and searchValue in favor of selectedValue
  searchByKey: _propTypes2.default.string,
  searchValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  selected: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.bool]),
  state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  shadow: _propTypes2.default.bool,
  template: _propTypes2.default.func,
  validationMessage: _propTypes2.default.string
};

Select.defaultProps = {
  size: 'medium',
  options: [],
  shadow: false
};

exports.default = Select;